import './styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/login';
import Home from './pages/home';
import UsrForm from './pages/adminstracion_usuarios';
import RolForm from './pages/administracion_roles';
import CambContrasena from './pages/cambio_contrasena';
import ProtectedRoute from "./components/protectedroute";
import Clientes from "./pages/clientes";
import Companias from "./pages/companias";
import Documentos from "./pages/documentos";
import Polizas from "./pages/polizas";
import FormPolizas from "./pages/formulario_polizas";
import ClientesPotenciales from "./pages/clientes_potenciales";

function App() {
  return (
      <Router>
        <Routes>
          {/* Ruta de Login */}
          <Route path="/login" element={<Login />} />
          
          {/* Ruta de Home */}
          <Route path="/inicio" element={<ProtectedRoute> <Home /> </ProtectedRoute>} />

          {/* Ruta de Home */}
          <Route path="/administracion/usuarios" element={<ProtectedRoute><UsrForm /></ProtectedRoute>} />
          
          {/* Ruta de Home */}
          <Route path="/administracion/roles" element={<ProtectedRoute><RolForm /></ProtectedRoute>} />

          {/* Ruta de Home */}
          <Route path="/cambio_contrasena" element={<ProtectedRoute><CambContrasena /></ProtectedRoute>} />
          
          {/* Ruta de Home */}
          <Route path="/clientes" element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
          
          {/* Ruta de Home */}
          <Route path="/companias" element={<ProtectedRoute><Companias /></ProtectedRoute>} />
          
          {/* Ruta de Home */}
          <Route path="/administracion/documentos" element={<ProtectedRoute><Documentos /></ProtectedRoute>} />

          {/* Ruta de Home */}
          <Route path="/polizas" element={<ProtectedRoute><Polizas /></ProtectedRoute>} />

          {/* Ruta de Home */}
          <Route path="/formulario_polizas/:id" element={<ProtectedRoute><FormPolizas /></ProtectedRoute>} />

          {/* Ruta de Home */}
          <Route path="/clientes_potenciales" element={<ProtectedRoute><ClientesPotenciales /></ProtectedRoute>} />         
        </Routes>
      </Router>
  );
}
export default App;
